import { useCallback } from "react";

import useAsync from "Common/useAsync";

import { fetchBrokerForm } from "./brokerForm.api";
import { BrokerForm } from "./brokerForm.types";

export const useFetchBrokerForm = () => {
  const asyncFunction = useCallback(() => fetchBrokerForm().then((response) => response.json()), []);
  const result = useAsync<BrokerForm>(asyncFunction);
  return result;
};
